import { render, staticRenderFns } from "./one_stop_trading.vue?vue&type=template&id=1d4dff1b&scoped=true&"
import script from "./one_stop_trading.vue?vue&type=script&lang=js&"
export * from "./one_stop_trading.vue?vue&type=script&lang=js&"
import style0 from "./one_stop_trading.vue?vue&type=style&index=0&id=1d4dff1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4dff1b",
  null
  
)

export default component.exports